import { lms_v2_api } from "../../../services/cs-lab-config"

function getPraphrasedSentence(payload) {
    return lms_v2_api.post("/chatbot/paraphraseContent",payload);
}

export { getPraphrasedSentence }